import React from 'react';
import GivelifyModal from '../../../../theme/GivelifyModal';
import SampleInviteTemplate from './SampleInviteTemplate';

interface SampleInviteModalProps {
    open: boolean;
    handleClose: () => unknown;
}

const defaultWidth = 864;
const SampleInviteModal: React.FC<SampleInviteModalProps> = ({
    open,
    handleClose,
}) => {
    return (
        <GivelifyModal
            label="Authorized Officer Invite Sample"
            isOpen={open}
            width={defaultWidth}
            handleClose={handleClose}
        >
            <SampleInviteTemplate />
        </GivelifyModal>
    );
};

export default SampleInviteModal;
